/* ASTRO SHOT core JS */
(function () {
  'use strict';
  if ('IntersectionObserver' in window) document.documentElement.classList.add('as-js');
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal(root) {
    var els = root.querySelectorAll('.as-reveal:not([data-as-rv])');
    if (!els.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.15 });
    els.forEach(function (el) { el.setAttribute('data-as-rv', '1'); io.observe(el); });
  }

  function initFaq(root) {
    root.querySelectorAll('.as-faq__item:not([data-as-faq])').forEach(function (item) {
      item.setAttribute('data-as-faq', '1');
      var btn = item.querySelector('.as-faq__q');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var wrap = item.closest('.as-section') || root;
        var open = item.classList.contains('is-active');
        wrap.querySelectorAll('.as-faq__item.is-active').forEach(function (o) { o.classList.remove('is-active'); var q = o.querySelector('.as-faq__q'); if (q) q.setAttribute('aria-expanded', 'false'); });
        if (!open) { item.classList.add('is-active'); btn.setAttribute('aria-expanded', 'true'); }
      });
    });
  }

  /* przewijane karuzele (opinie): strzałki + kropki */
  function initRail(root) {
    root.querySelectorAll('.as-rail:not([data-as-rail])').forEach(function (wrap) {
      wrap.setAttribute('data-as-rail', '1');
      var track = wrap.querySelector('.as-rail__track');
      var prev = wrap.querySelector('[data-as-prev]');
      var next = wrap.querySelector('[data-as-next]');
      if (!track) return;
      function step() { var c = track.querySelector(':scope > *'); return c ? c.getBoundingClientRect().width + 20 : 300; }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduced ? 'auto' : 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduced ? 'auto' : 'smooth' }); });
    });
  }

  /* ARENA: mini gra — wybierz drużynę, trafiaj zapalone sensory przeciwników */
  function initArena(root) {
    root.querySelectorAll('.as-arena:not([data-as-ar])').forEach(function (wrap) {
      wrap.setAttribute('data-as-ar', '1');
      var pads = Array.prototype.slice.call(wrap.querySelectorAll('.as-arena__pad'));
      var teams = Array.prototype.slice.call(wrap.querySelectorAll('.as-arena__team'));
      var startBtn = wrap.querySelector('.as-arena__start');
      var scoreEl = wrap.querySelector('[data-as-score]');
      var bestEl = wrap.querySelector('[data-as-best]');
      var accEl = wrap.querySelector('[data-as-acc]');
      var timeEl = wrap.querySelector('[data-as-time]');
      var bar = wrap.querySelector('.as-arena__bar i');
      var msg = wrap.querySelector('[data-as-msg]');
      if (!pads.length || !startBtn) return;
      var COLORS = { red: 'var(--as-red)', green: 'var(--as-green)', yellow: 'var(--as-yellow)', blue: 'var(--as-team-blue)' };
      var DURATION = (parseInt(wrap.getAttribute('data-duration'), 10) || 20) * 1000;
      var my = 'blue', running = false, lit = -1, score = 0, shots = 0, best = 0, t0 = 0, raf = 0, litTimer = 0, speed = 1000;
      var tiers = (wrap.getAttribute('data-tiers') || '').split('|');

      function setTeam(name) {
        my = name;
        wrap.style.setProperty('--my', COLORS[name] || COLORS.blue);
        teams.forEach(function (t) { var on = t.getAttribute('data-team') === name; t.classList.toggle('is-active', on); t.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      }
      teams.forEach(function (t) { t.addEventListener('click', function () { if (!running) setTeam(t.getAttribute('data-team')); }); });
      setTeam(my);

      function enemy() { var k = Object.keys(COLORS).filter(function (c) { return c !== my; }); return k[Math.floor(Math.random() * k.length)]; }
      function clearPads() { pads.forEach(function (p) { p.classList.remove('is-live'); }); lit = -1; }
      function light() {
        clearPads();
        var i; do { i = Math.floor(Math.random() * pads.length); } while (pads.length > 1 && i === lastLit);
        lastLit = i; lit = i;
        pads[i].style.setProperty('--c', COLORS[enemy()]);
        pads[i].classList.add('is-live');
        clearTimeout(litTimer);
        litTimer = setTimeout(function () { if (running) light(); }, speed);
      }
      var lastLit = -1;
      function render() {
        if (scoreEl) scoreEl.textContent = String(score);
        if (accEl) accEl.textContent = shots ? Math.round(score / shots * 100) + '%' : '–';
        if (bestEl) bestEl.textContent = String(best);
      }
      function tick() {
        var left = Math.max(0, DURATION - (Date.now() - t0));
        if (timeEl) timeEl.textContent = (left / 1000).toFixed(1).replace('.', ',') + ' s';
        if (bar) bar.style.transform = 'scaleX(' + (left / DURATION) + ')';
        if (left <= 0) { stop(true); return; }
        raf = requestAnimationFrame(tick);
      }
      function start() {
        running = true; score = 0; shots = 0; speed = reduced ? 1500 : 1000; t0 = Date.now();
        wrap.classList.add('is-running'); wrap.classList.remove('is-done');
        startBtn.querySelector('span').textContent = startBtn.getAttribute('data-stop') || 'Stop';
        if (msg) msg.textContent = '';
        render(); light(); tick();
      }
      function stop(finished) {
        running = false; cancelAnimationFrame(raf); clearTimeout(litTimer); clearPads();
        wrap.classList.remove('is-running');
        startBtn.querySelector('span').textContent = startBtn.getAttribute('data-again') || 'Zagraj ponownie';
        if (finished) {
          best = Math.max(best, score); render(); wrap.classList.add('is-done');
          if (msg && tiers.length >= 3) { msg.textContent = (score >= 18 ? tiers[2] : score >= 10 ? tiers[1] : tiers[0]).replace('[n]', score); }
        }
      }
      startBtn.addEventListener('click', function () { running ? stop(false) : start(); });
      pads.forEach(function (pad, i) {
        pad.addEventListener('click', function () {
          if (!running) return;
          shots += 1;
          if (i === lit) {
            score += 1; speed = Math.max(reduced ? 1200 : 520, speed - 30);
            pad.classList.add('is-hit'); setTimeout(function () { pad.classList.remove('is-hit'); }, 260);
            if (scoreEl) { scoreEl.style.animation = 'none'; void scoreEl.offsetWidth; scoreEl.style.animation = 'as-pop 0.35s ease'; }
            light();
          } else {
            pad.classList.add('is-miss'); setTimeout(function () { pad.classList.remove('is-miss'); }, 260);
          }
          render();
        });
      });
      render();
    });
  }

  function initAll(scope) { var r = scope || document; initReveal(r); initFaq(r); initRail(r); initArena(r); }
  if (document.readyState !== 'loading') initAll(document); else document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
